<template>
    <el-tree-select style="width: 100%" v-model="newValue" :current-node-key="newValue" :data="options"
        :node-key="fieldNames?.value" :filterable="filterable" :expand-on-click-node="false" value-key="fieldNames.value"
        :render-after-expand="false" :default-expand-all="false" @current-change="currentChange" :props="fieldNames"
        :placeholder="i18nConfig(placeholder)" :node-class-name="nodeClassName">
        <template #default="{ node, data }">
            <slot :node="node" :data="data">
                <!-- 默认插槽内容：显示节点标签 -->
                <span class="tree-node-label" :class="getNodeClass(data)">
                    {{ data[fieldNames.label] }}
                </span>
            </slot>
        </template>
    </el-tree-select>
</template>

<script>
import treeCustomFunction from './tree-custom-function.js';
import { i18nConfig } from '@/utils/ruoyi'
import { treeselect } from "@/api/system/dept";
import { reactive, toRefs, onMounted, watch, getCurrentInstance } from "vue"
export default {
    name: "gljy-tree-select",
    emits: ["update:value", "update:label", "update:treeCode", "currentChange"],
    props: {
        value: {
            type: [String, Array]
        },
        isToTree: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        isAutoInit: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        /**
         * queryFunction:通过传入的查询函数,设置下拉框的下拉内容
         * 其他类型: 将类型通过数据字典工具向后台得到数据
         */
        type: {
            type: String,
            default: "queryFunction"
        },
        // 查询函数--type-queryFunction时,此函数必须配置
        queryFunction: {
            type: [Function, Promise],
            default: (proxy) => {
                // 如果是预设的function, 那么获取后续的拼接参数, 从js中得到预设function
                if (proxy.type.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return treeCustomFunction[presetFunctionObjKey]?.queryFunction;
                }
                return () => {
                };
            }
        },
        // 是否插入顶级栏目
        isTopLevel: {
            type: Boolean,
            default: false
        },
        // 查询条件--跟queryFunction配套使用
        extendQueryWhere: {
            type: Object,
            default: (proxy) => {
                if (proxy.type.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return treeCustomFunction[presetFunctionObjKey]?.extendQueryWhere;
                }
                return {}
            }
        },
        placeholder: {
            type: String,
            default: "请选择"
        },
        fieldNames: {
            type: Object,
            default: (proxy) => {
                if (proxy.type.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return treeCustomFunction[presetFunctionObjKey]?.fieldNames;
                }
                return { value: 'id', label: 'label', children: 'children', parentId: 'parentId', treeCode: 'treeCode' }
            }
        },
        filterable: {
            // 是否支持筛选
            type: Boolean,
            default: () => {
                return true;
            }
        },
        // 支持清除
        clearable: {
            type: Boolean,
            default: true
        },
        // 节点样式处理函数，由外部传入
        nodeClassHandler: {
            type: Function,
            default: () => {
                return '';
            }
        },
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance();

        const datas = reactive({
            newValue: undefined,
            options: [],
            i18nConfig: i18nConfig
        })

        watch(() => props.value, () => {
            datas.newValue = props.value ? props.value : undefined;
        }, { immediate: true })

        onMounted(() => {
            if (props.isAutoInit) {
                methods.init();
            }
        })

        const methods = {
            // 初始化
            async init(params) {
                datas.options = [];
                const data = {};
                data[props.fieldNames.value] = 0;
                data[props.fieldNames.label] = "顶级节点";
                data.children = [];
                let requestParams = {}
                if (props.extendQueryWhere) {
                    Object.keys(props.extendQueryWhere).forEach(key => {
                        requestParams[key] = props.extendQueryWhere[key]
                    })
                }
                if (params) {
                    Object.keys(params).forEach(key => {
                        requestParams[key] = params[key]
                    })
                }
                if (props.type.indexOf("presetFunction") >= 0 || props.type == "queryFunction") {
                    const res = await props.queryFunction(requestParams);
                    if (res.code == 200) {
                        if (props.isToTree) {
                            data.children = proxy.handleTree(res.data, props.fieldNames.value, props.fieldNames.parentId);
                            if (props.isTopLevel) {
                                datas.options.push(data);
                            } else {
                                datas.options.push(...data.children);
                            }
                        } else {
                            // 直接使用API返回的数据（已经是树结构）
                            datas.options = res.data || [];
                        }
                    }
                }
            },
            currentChange(info, nodeObj) {
                console.log('gljy-tree-select currentChange, info:', info, 'nodeObj:', nodeObj);
                // 根据 fieldNames 配置获取对应的字段值
                const nodeValue = info[props.fieldNames.value];
                const nodeLabel = info[props.fieldNames.label];
                const nodeTreeCode = info[props.fieldNames.treeCode];
                console.log('Emitting value:', nodeValue, 'label:', nodeLabel, 'treeCode:', nodeTreeCode);
                context.emit("update:value", nodeValue);
                context.emit("update:label", nodeLabel);
                context.emit("update:treeCode", nodeTreeCode || null);
                context.emit("currentChange", info, nodeObj);
            },
            nodeClassName(data) {
                // 调用外部传入的样式处理函数
                return props.nodeClassHandler(data) || '';
            },
            getNodeClass(data) {
                // 调用外部传入的样式处理函数
                return props.nodeClassHandler(data) || '';
            }
        }

        return {
            ...toRefs(datas),
            ...methods
        }
    }
}
</script>

<style>
/* 节点标签样式 - 外部组件可通过插槽自定义样式 */
:deep(.tree-node-label) {
    display: inline-flex;
    align-items: center;
}
</style>